import { MutationTree } from 'vuex'
import { ConstructionConnectionState } from './types'
import { idGenerator } from '@/services'

export const mutations: MutationTree<ConstructionConnectionState> = {
  RESET(state) {
    state.requestId = idGenerator.getNewWebReference()
  }
}
